import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActionService} from '../../_services/action.service';
import {Subscription} from 'rxjs';
import {DatatableComponent, DataTableDataSource, HelpMessage, TableAction} from '@cas-hub/acabim-common-client';
import {ActionDataSource} from './action.datatable';
import {map} from 'rxjs/operators';
import {ActionDisplayResponse} from '../../_models/action.model';
// import {ActionDisplayResponse} from '../../_models/action.model';

@Component({
  selector: 'acabim-admin-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit, OnDestroy {

  @ViewChild('dataTable') public dataTable!: DatatableComponent;

  actionSub: Subscription = new Subscription();
  addActionModal = false;
  archiveActionModal = false;
  detailsActionModal = false;
  dataSources: DataTableDataSource<any>[] = [];
  selectedAction: ActionDisplayResponse | null = null;
  selectedActions: ActionDisplayResponse[] = [];
  actionOptions: TableAction[] = [
    {name: 'Archive', id: 0},
  ];
  helpMessage: HelpMessage = {
    message: 'Here is a list of maintenance actions that you can add to the maintenance schedule. ' +
        'Click on the eye-icon next to the action name to manage its properties.'
  };

  constructor(
      private readonly actionService: ActionService
  ) { }

  ngOnInit(): void {
    this.dataSources = [];
    this.dataSources.push(new ActionDataSource(
        this.actionOptions,
        (pagination) => {
          return this.actionService.getActions(pagination).pipe(map(data => {
            console.dir(data);
            return data;
          }));
        },
        () => {},
        () => {},
        (action: TableAction) => { this.handleActions(action); }
    ));
  }

  ngOnDestroy(): void {
    this.actionSub.unsubscribe();
  }

  toggleAddStatus(value: boolean): void {
    this.addActionModal = value;
  }

  toggleDetailStatus(value: any): void {
    this.detailsActionModal = value;
  }

  closeHandler(type: string, value: string) {
    if (value === 'completed') {
      this.dataTable.requestImmediateDataRefresh();
    }
    if (type === 'add') {
      this.addActionModal = false;
    } else if (type === 'archived') {
      this.dataSources[0].selectedData = [];
      this.archiveActionModal = false;
      this.dataTable.requestImmediateDataRefresh();
    } else {
      this.detailsActionModal = false;
    }
  }

  toggleArchiveStatus(value: any): void {
    this.archiveActionModal = value;
  }

  setDetails(value: any): void {
    this.selectedAction = value;
    this.detailsActionModal = true;
  }

  handleActions(action: TableAction): void {
      if (action.id === 0) {
        this.selectedActions = this.dataSources[0].selectedData;
        this.archiveActionModal = true;
      }
  }

}
